define('views/blocks/ConsumableOptionsPopinView',['jquery', 'underscore','backbone', 'app', 
    'template!blocks/consumable-options-popin',
    ],
    function ($, _, Backbone, app, ConsumableOptionsPopinTemplate) {

    var consumables, max_sauce;

    var ConsumableOptionsPopinView = Backbone.View.extend({
        events: {
            'click .consumable-badge--qty': 'changeConsumable',
            'click .consumable-options__mobile-close, .consumable-options__mobile-cta-validate': 'closeConsumableModal',
        },
        initialize: function(options) {
            var view = this;
            var cart = view.cart = app.getCart();
            var consumableCollection = cart.getOfferedProducts();

            view.consumables = consumableCollection;
            view.listenTo(consumableCollection,'change:free change:quantity',view.onChange);

            $('.modals-wrapper').css('overflow', 'hidden')

            consumables = options.consumables;
            max_sauce = options.max_sauce;
            this.render();
        },
        onChange:function(consumableModel,freeQuantity){
            this.refresh();
        },
        closeConsumableModal: function() {
            $('.modals-wrapper').css('overflow', 'auto')
            this.trigger('close', this)
        },
        changeConsumable: function(e) {
            var view = this,
                button = $(e.currentTarget),
                parent = button.parent(),
                slug = parent.attr('data-slug'),
                consumable = view.consumables.getModelBySlug(slug),
                curQty = consumable.getQuantity(),
                addQty = button.is('.add-quantity') ? 1 : -1,
                newQty = addQty + curQty;
            view.usePreset = false;
            consumable.setQuantity(newQty);
            this.setConsumable(false);
        },
        refresh:function(){
            var view = this;
            view.consumables.each(function(consumable){
               var $el = view.$('.consumable-'+consumable.id),
                qty = consumable.getQuantity();
                $el.find('.consumable-quantity').attr('data-quantity',qty);
                $el.find('.consumable-price')
                    .attr('data-price',consumable.formatPriceType())
                    .text(consumable.formatPrice(true));
                $el.find('.less').attr('disabled',qty===0);
                $el.find('.more').attr('disabled',qty >= consumable.getQuantityMax());
            });
        },
        setConsumable:function(close){
            var view = this,
                consumables = view.consumables;
            //
            if(view.usePreset){
                consumables.requestPreset();
            }else {
                consumables.requestSet();
            }
            if(close)
            {
                this.close();
            }
        },
        render: function() {
            this.$el.html(ConsumableOptionsPopinTemplate(
                {
                    consumables: consumables,
                    max_sauce: max_sauce
                }
            ))
        },
    });

    return ConsumableOptionsPopinView;
});

